import React, { Component, Suspense } from "react";
import {
  AboutCard,
  RecognitionCard,
  // DevicesCard,
  RecognitionCardV2,
  // DevicesCardV2,
} from "./style";
import {
  OverviewCard,
  WellnessCardNew,
  InitiativesCard,
  InterestCardNew,
  DropdownContentNew,
} from "../UserProfile/styles";
import PropTypes from "prop-types";
import { ImageUrl } from "../../utils/constants";
import moment from "moment";
// import { getLastSyncDetails } from "../../utils/methods";
import Waiting from "../Waiting";
import styled from "styled-components";
import ProfileEditForm from "../UserProfile/ProfileEditForm";
import { Checkmark, EditIconNew } from "../../utils/icons";
import { connect } from "react-redux";
import { UpdateUserDetails, getUserDetails } from "../../redux/actions";

// const HoverButton = React.lazy(() => import("../../components/common/HoverButton"));
const DevicePopup = React.lazy(() => import("./deviceSyncPopup"));

const DynamicOverviewCard = styled(OverviewCard)`
  height: ${(props) => props.isEditMode ? 'auto' : '360px'};
  min-height: ${(props) => props.isEditMode ? '400px' : '360px'};
`;

const WellnessData = [
  "Individual Sports",
  "Water Sports",
  "Ball Sports",
  "Wheel Sports",
  "Winter Sports",
  "Combat Sports",
  "Resistance Training",
  "Other",
];

class Overview extends Component {
  profileEditFormRef = null;

  constructor() {
    super();
    this.state = {
      showDevicepoup: false,
      isEditMode: false,
    };
  }

  showPopup = (status) => {
    this.setState({ showDevicepoup: status });
  };

  toggleEditMode = () => {
    this.setState({ isEditMode: !this.state.isEditMode });
  };

  handleButtonClick = () => {
    if (this.state.isEditMode) {
      if (this.profileEditFormRef) {
        this.profileEditFormRef.handleSave();
      }
    } else {
      this.toggleEditMode();
    }
  };

  handleSaveData = (data) => {
    const { UpdateUserDetails, getUserDetails, setUserDetails } = this.props;
    const uid = setUserDetails?.user?.uid;
    
    if (UpdateUserDetails && getUserDetails && uid) {
      const payload = {
        uid: uid,
        fname: data.fname,
        lname: data.lname,
        mail: data.mail,
        employee_id: data.employee_id,
        phone_number: data.phone_number,
        country: data.country,
        birthday: data.birthday,
        visible_birthday: data.visible_birthday !== undefined ? data.visible_birthday : (setUserDetails?.user?.visible_birthday ? 1 : 0),
        work_anniversary: data.work_anniversary_date,
        city_state_id: data.city_state_id,
        department_id: data.department_id
      };
      
      UpdateUserDetails(payload, uid);
      this.setState({ isEditMode: false });
      window.setTimeout(() => {
        getUserDetails(uid);
      }, 500);
    }
  };

  handleCancel = () => {
    this.setState({ isEditMode: false });
  };

  refreshButtonIcon = () => (
    <svg
      width="20"
      height="24"
      viewBox="0 0 20 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.0001 11.9993C20.0001 9.42219 18.9558 6.97149 17.0759 5.15238C16.5537 4.64712 15.666 4.64712 15.1437 5.15238C14.5953 5.65765 14.5953 6.51663 15.1437 7.02207C16.5275 8.36114 17.2585 10.1045 17.2585 11.9994C17.2585 15.4355 14.6998 18.2904 11.3578 18.8968V17.3304C11.3578 16.7997 10.7311 16.5218 10.3135 16.8251L6.24021 19.8569C5.90073 20.1097 5.90073 20.5896 6.24021 20.8423L10.3133 23.8741C10.7311 24.1772 11.3576 23.8993 11.3576 23.3688L11.3578 21.6003C16.2403 20.9433 20.0001 16.9009 20.0001 11.9994L20.0001 11.9993Z"
        fill="#9C9C9C"
      />
      <path
        d="M2.74151 12C2.74151 8.56389 5.30022 5.7089 8.64231 5.10253V6.66894C8.64231 7.1996 9.26899 7.47752 9.6866 7.1742L13.7597 4.16757C14.0992 3.91484 14.0992 3.43496 13.7597 3.18222L9.68679 0.125195C9.26899 -0.177936 8.6425 0.0999933 8.6425 0.630458L8.64231 2.39899C3.7598 3.03063 0 7.09836 0 11.9998C0 14.577 1.04429 17.0277 2.92424 18.8468C3.18541 19.0995 3.55092 19.2257 3.89025 19.2257C4.22974 19.2257 4.59526 19.0993 4.85627 18.8468C5.40466 18.3415 5.40466 17.4825 4.85627 16.9771C3.4987 15.638 2.74161 13.8695 2.74161 11.9998L2.74151 12Z"
        fill="#9C9C9C"
      />
    </svg>
  );

  render() {
    const {
      setUserDetails,
      // role,
      userWellnessInterest,
      wellnessInterests,
      userConnectedDevice,
      shoutOutData,
      userInitiativesData,
      companyBranding,
    } = this.props;

    const { isEditMode } = this.state;

    const RegistrationDate =
      setUserDetails && setUserDetails?.user?.created_at
        ? moment(setUserDetails?.user?.created_at).format("MM/DD/YYYY")
        : "NA";

    const { showDevicepoup } = this.state;
    const deviceSynced = userConnectedDevice && userConnectedDevice.connected_devices;
    const userId = setUserDetails && setUserDetails?.user?.uid;

    const showAboutCard = Boolean(setUserDetails?.user?.bio);

    const showInitiativesCard = Boolean(
      userInitiativesData?.initiatives?.length &&
      companyBranding?.company_branding?.show_biometric
    );

    const showRecognitionCard = Boolean(
      companyBranding?.company_branding?.show_recognition &&
      shoutOutData?.shoutout_count?.length > 0 &&
      shoutOutData.shoutout_count.some((item) => item.count > 0)
    );


    // const showDevicesCard = Boolean(
    //   userConnectedDevice &&
    //   userConnectedDevice.connected_devices &&
    //   userConnectedDevice.connected_devices.length > 0
    // );

    return (
      <div style={{ marginBottom: "10%" }}>
        <DynamicOverviewCard isEditMode={isEditMode}>
          <div className="prof-details">
            <div className="name-in">Personal Details</div>
            <button onClick={this.handleButtonClick} className={`user-edit-btn ${!isEditMode ? 'no-background' : ''}`}>
              {isEditMode ? (
                <>
                  Save Changes
                  <span style={{ marginLeft: '8px' }}>{Checkmark()}</span>
                </>
              ) : (
                <>
                  Edit
                  <span style={{ marginLeft: '8px' }}>{EditIconNew()}</span>
                </>
              )}
            </button>
          </div>
          <div className="view-card">
            {!isEditMode ? (
              <div className="emp-detail">
                <div className="fieldNames">
                  <div className="label-name-emp">Full Name: </div>
                  <div className="prof-data">
                    {setUserDetails && setUserDetails?.user?.fname}{" "}
                    {setUserDetails && setUserDetails?.user?.lname}
                  </div>
                </div>
                <div className="fieldNames">
                  <div className="label-name-emp">Department: </div>
                  <div className="prof-data">
                    {setUserDetails && setUserDetails?.user?.department !== null
                      ? setUserDetails?.user?.department
                      : "NA"}
                  </div>
                </div>
                <div className="fieldNames">
                  <div className="label-name-emp">Company: </div>
                  <div className="prof-data">
                    {setUserDetails && setUserDetails?.user?.company_name !== null
                      ? setUserDetails?.user?.company_name
                      : "NA"}
                  </div>
                </div>
                <div className="fieldNames">
                  <div className="label-name-emp">Location: </div>
                  <div className="prof-data">
                    {setUserDetails && setUserDetails?.user?.location !== null
                      ? setUserDetails?.user?.location
                      : "NA"}
                  </div>
                </div>
                <div className="fieldNames">
                  <div className="label-name-emp">Email: </div>
                  <div className="prof-data">
                    {setUserDetails && setUserDetails?.user?.mail !== null
                      ? setUserDetails?.user?.mail
                      : "NA"}
                  </div>
                </div>
                <div className="fieldNames">
                  <div className="label-name-emp">Country: </div>
                  <div className="prof-data">
                    {setUserDetails && setUserDetails?.user?.country !== null
                      ? setUserDetails?.user?.country
                      : "NA"}
                  </div>
                </div>
                <div className="fieldNames">
                  <div className="label-name-emp">Contact: </div>
                  <div className="prof-data">
                    {setUserDetails && setUserDetails?.user?.phone_number !== null
                      ? setUserDetails?.user?.phone_number
                      : "NA"}
                  </div>
                </div>
                <div className="fieldNames">
                  <div className="label-name-emp">Birthday {setUserDetails && setUserDetails?.user?.birthday !== null && (
                    <span style={{ marginLeft: '4px', color: '#989898', fontSize: '14px' }}>
                      ({setUserDetails?.user?.visible_birthday ? 'Public' : 'Private'}):
                    </span>
                  )}</div>
                  <div className="color">
                    {setUserDetails && setUserDetails?.user?.birthday !== null
                      ? moment(setUserDetails?.user?.birthday).format("DD MMMM YYYY")
                      : "NA"}
                  </div>
                </div>
                <div className="fieldNames" style={{ borderBottom: "none" }}>
                  <div className="label-name-emp">Registration Date: </div>
                  <div className="prof-data">
                    {setUserDetails && setUserDetails?.user?.created_at
                      ? RegistrationDate
                      : "NA"}
                  </div>
                </div>
                <div className="fieldNames" style={{ borderBottom: "none" }}>
                  <div className="label-name-emp">Work Anniversary: </div>
                  <div className="green">
                    {setUserDetails && setUserDetails?.user?.work_anniversary_date !== null
                      ? moment(setUserDetails?.user?.work_anniversary_date).format("DD MMMM YYYY")
                      : "NA"}
                  </div>
                </div>
              </div>
            ) : (
              <ProfileEditForm 
                onRef={(ref) => { this.profileEditFormRef = ref; }}
                user={setUserDetails?.user}
                onSave={this.handleSaveData}
                onCancel={this.handleCancel}
                isAdminView={true}
                showAdminFields={true}
              />
            )}
          </div>
        </DynamicOverviewCard>

        {userWellnessInterest &&
          userWellnessInterest.interest &&
          userWellnessInterest.interest.length > 0 &&
          wellnessInterests && (
          <WellnessCardNew style={{ background: "none", padding: "0" }}>
            <div className="prof-details">
              <div className="name-in">Wellness Interests</div>
            </div>
            <div className="view-card" style={{ marginTop: "10px" }}>
              <div style={{ background: "#fff", borderRadius: "12px", border: "0.75px solid #DCDCDC" }}>
                {WellnessData.map((data, index) => {
                  const categoryInterests = wellnessInterests.filter((item) =>
                    item?.interest_type?.toLowerCase().trim() === data.toLowerCase().trim() &&
                    userWellnessInterest.interest.some((userInt) => userInt.interest_id === item.id)
                  );

                  if (!categoryInterests || categoryInterests.length === 0) return null;

                  return (
                    <InterestCardNew key={index}>
                      <div className="title" style={{ color: "#989898" }}>{data}</div>
                      <div className="dropdown-wrapper">
                        {categoryInterests.map((listData, idx) => (
                          <DropdownContentNew userInterest={true} key={idx}>
                            <img
                              src={`${ImageUrl}/${listData?.interest_white_icon}`}
                              className="category-img"
                              alt="category"
                            />
                            <div className="listContent">{listData?.name}</div>
                          </DropdownContentNew>
                        ))}
                      </div>
                    </InterestCardNew>
                  );
                })}
              </div>
            </div>
          </WellnessCardNew>
        )}

        {showAboutCard && (
          <AboutCard>
            <div className="about-user-section">
              <div className="title-text">
                About {setUserDetails?.user?.fname}
              </div>
              <hr className="horizontal-line" />
              <div className="about-user-details">
                {setUserDetails?.user?.bio}
              </div>
            </div>
          </AboutCard>
        )}

        {showInitiativesCard && (
          <div style={{width:'100% !important', display:'display: flex;'}}>
            <div className="company-initative">
              <div className="heading" style={{ marginBottom: "10px",fontFamily:'lato',fontWeight:'bold',fontSize:'18px',lineHeight:'24px',color:'#184A61' }}>
                My Company Initiatives
              </div>

              <div className="fitness-wrapper" style={{ display:'flex',flexWrap: "wrap", gap: "20px 20px", padding: "0" }}>
                {userInitiativesData?.initiatives?.map((data, index) => {
                  const completedDate = moment(new Date(data?.date)).format("MMM DD");
                  return (
                    <InitiativesCard key={index} color={data?.color}>
                      <div className="icon">
                        <img
                          src={ImageUrl + "/" + data?.initiative_white_icon}
                          alt="icon"
                        />
                      </div>
                      <div className="wrap">
                        <div className="title">{data?.name}</div>
                        <div className="points">+{data?.points} pts</div>
                        {data?.is_taken && (
                          <div className="completed">Completed on {completedDate}</div>
                        )}
                        {/* {data?.is_taken ? 
                        <div className='completed'>Completed on {completedDate}</div> :
                        !isAdminView && (
                          <div className='initiative-button' onClick={() => this.showInitiativeModal(data)}>
                            Log Initiative {AdminRightArrowIcon("#DA6C74")}
                          </div>
                        )
                      } */}
                      </div>
                    </InitiativesCard>
                  );
                })}
              </div>
            </div>
          </div>
        )}

        {showRecognitionCard && (
          <RecognitionCard>
            <div className="recognize-received">
              <div className="heading2">
                My {moment().format("YYYY")} Recognitions Received
              </div>

              <div className="welcome-wrapper">
                {shoutOutData.shoutout_count
                  .filter((item) => item.count > 0)
                  .map((item, index) => (
                    <RecognitionCardV2
                      key={index}
                      marginRight={(index + 1) % 4 === 0 ? "0px" : "25px"}
                      backgroundColor={item.color}
                      color="#092F41"
                    >
                      <div className="imgNew">
                        <img src={`${ImageUrl}/${item.icon}`} alt="recognition icon" />
                      </div>
                      <div className="welldone-card-text" title={item.name}>
                        {item.name}
                        <div className="point">{item.count}</div>
                      </div>
                    </RecognitionCardV2>
                  ))}
              </div>
            </div>
          </RecognitionCard>
        )}

        {/* {showDevicesCard && (
          <DevicesCard>
            <div className="connect-devices">
              <div className="wrapperHeading">
                <div className="headingNew">My Connected Devices</div>
                <div className="refreshbutton">
                  {role === "ADMIN" && (
                    <Suspense fallback={<div />}>
                      <HoverButton
                        title={"Refresh"}
                        svgPath={this.refreshButtonIcon()}
                        onClick={() => this.showPopup(true)}
                        height="24px"
                        width="20px"
                      />
                    </Suspense>
                  )}
                </div>
              </div>
              <hr className="horizontal-line" />
              <div className="device-wrapper">
                {userConnectedDevice.connected_devices.map((item, index) => (
                  <DevicesCardV2
                    key={index}
                    marginRight={(index + 1) % 3 === 0 ? "0px" : "25px"}
                  >
                    <div className="img2">
                      <img src={`${ImageUrl}/${item.device_image}`} alt="device" />
                    </div>
                    <div className="wrapper">
                      <div className="watch-title">{item.device_name}</div>
                      {item.last_sync && (
                        <div className="bits">
                          Last Sync {getLastSyncDetails(item.last_sync)}
                        </div>
                      )}
                    </div>
                  </DevicesCardV2>
                ))}
              </div>
            </div>
          </DevicesCard>
        )} */}

        <Suspense fallback={<Waiting />}>
          {showDevicepoup && (
            <DevicePopup
              showModal={showDevicepoup}
              closeModal={this.showPopup}
              deviceSynced={deviceSynced}
              userId={userId}
            />
          )}
        </Suspense>
      </div>
    );
  }
}

Overview.propTypes = {
  userModal: PropTypes.func,
  setUserDetails: PropTypes.object,
  role: PropTypes.string,
  userWellnessInterest: PropTypes.object,
  wellnessInterests: PropTypes.array,
  userConnectedDevice: PropTypes.object,
  shoutOutData: PropTypes.object,
  userInitiativesData: PropTypes.object,
  companyBranding: PropTypes.object,
  isManagerRoute: PropTypes.bool,
  UpdateUserDetails: PropTypes.func,
  getUserDetails: PropTypes.func,
};

const mapDispatchToProps = (dispatch) => ({
  UpdateUserDetails: (obj, uid) => dispatch(UpdateUserDetails(obj, uid)),
  getUserDetails: (id) => dispatch(getUserDetails(id)),
});

export default connect(null, mapDispatchToProps)(Overview);
